<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
  v-card
    .py-6.px-10
      .text-xl.font-medium.mb-4 {{ $t('revoke_confirmation_title') }}
      .text-md.font-normal.mb-4.pre-wrap {{ $t('revoke_confirmation_description') }}
      .text-md.font-semibold.mb-1.neutral500--text {{ $t('revoke_confirmation_label') }}
      v-text-field.text-sm.mt-2.round-xl(v-model="input" outlined hide-details)
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="$emit('confirm')" :loading="loading" color="danger500" :disabled="!canProceed" :dark="canProceed" depressed) {{ $t('confirm') }}
</template>

<script>
export default {
  name: 'RevokeApiKeyDialog',
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      input: null
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    canProceed() {
      return this.input === 'DELETE'
    }
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.pre-wrap {
  white-space: pre-wrap;
}
</style>